// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";
import { es } from "vuetify/locale";

// Detectar el modo oscuro del sistema
const darkModeMediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
const isDarkMode = darkModeMediaQuery.matches;

// Configuración de Vuetify combinada
export default createVuetify({
  locale: {
    locale: "es", // Establece el idioma predeterminado a español
    messages: { es }, // Mensajes de localización en español
  },
  theme: {
    defaultTheme: isDarkMode ? "dark" : "light", // Establece el tema predeterminado según el sistema
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#424242",
          secondary: "#f2cd14",
          accent: "#f2cd14",
          error: "#FF5252",
          info: "#2196F3",
          success: "#4CAF50",
          warning: "#FFC107",
        },
      },
      dark: {
        dark: true,
        colors: {
          primary: "#f2cd14",
          secondary: "#FFB300",
          accent: "#f2cd14",
          error: "#D32F2F",
          info: "#FFC107",
          success: "#B2FF59",
          warning: "#FB8C00",
        },
      },
    },
  },
  icons: {
    defaultSet: "mdi", // Usa el conjunto de iconos 'mdi'
  },
});
